import { useSelector } from 'react-redux';
import { LOADING_STATUS } from 'shared/constants';
import { RootState } from 'store';

export const useUserGeoPosition = () => {
  const geoPosition = useSelector((state: RootState) => state['USER'].geoPosition.geoCords);
  return geoPosition;
};

export const useIsLoadingGeoPosition = () => {
  const loadingStatus = useSelector((state: RootState) => state['USER'].geoPosition.loadingStatus);
  return loadingStatus === LOADING_STATUS.load;
};
